// extracted by mini-css-extract-plugin
export const root = "vimeo-player-module--root--3tBIB";
export const player = "vimeo-player-module--player--1Rbsk";